import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setMessage } from "../slices/message";
import { BASE_URL } from "./common";

// Define a service using a base URL and expected endpoints
export const coursesApi = createApi({
  reducerPath: "coursesApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    getCourses: builder.query({
      query: ({ year, term }) => `/api/courses?year=${year}&term=${term}`,
      transformResponse: (response, meta, arg) => {
        return [
          "",
          ...response.data
            .map((course) => `${course.number} - ${course.title}`)
            .sort(),
        ];
      },
      async onQueryStarted({ year, term }, { dispatch, queryFulfilled }) {
        try {
          const data = await queryFulfilled;
          // TODO store the courses?
        } catch (err) {
          const msg =
            (err && err.error && err.error.data && err.error.data.message) ||
            "An error has occurred when fetching courses.";
          dispatch(
            setMessage({ text: msg, error: JSON.stringify(err, null, 2) })
          );
        }
      },
    }),
  }),
});

export const { useGetCoursesQuery } = coursesApi;
